<template>
  <div class="modal fade" id="grantAppReminderDetailsModal">
    <div class="modal-dialog" role="document">
      <div v-if="grantApplicationReminder != null" class="modal-content">
        <div
          class="modal-header"
          v-bind:class="
            $getClassForGrantApplicationStatus(
              grantApplicationReminder.grantApplication.Grant_Application_Status
                .Grant_Application_Status_Id
            )
          "
        >
          <h5 class="modal-title">
            {{ grantApplicationReminder.grantApplication.Grant.Title }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <label>Reminder:</label>
          <h5>{{ grantApplicationReminder.grantReminder.Description }}</h5>
          <label>Date:</label>
          <h5>
            {{ $displayDate(grantApplicationReminder.grantReminder.Date) }}
          </h5>
          <div class="text-right">
            <button
              v-on:click="
                gotToGrant(
                  grantApplicationReminder.grantApplication.Grant_Application_Id
                )
              "
              class="btn btn-primary"
            >
              Go To Grant
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import datepicker from "vuejs-datepicker";
import $ from "jquery";

export default {
  name: "GrantAppReminderModal",
  components: {
    //datepicker
  },
  props: {
    GrantApplicationReminder: Object
  },
  data() {
    return {
      grantApplicationReminder: this.GrantApplicationReminder
    };
  },
  watch: {
    GrantApplicationReminder: function() {
      this.grantApplicationReminder = this.GrantApplicationReminder;
    }
  },
  mounted() {},
  methods: {
    gotToGrant(grantApplicationId) {
      $("#grantAppReminderDetailsModal").modal("hide");
      this.$router.push({
        name: "mygrants",
        params: { id: grantApplicationId }
      });
    }
  }
};
</script>

<style>
#grantReminderDate {
  width: 100%;
  height: calc(1.5rem + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  color: #495057;
  line-height: 1.5;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}
</style>
